var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.33069,
    y: 3.33319,
    width: 21.3333,
    height: 21.3333,
    rx: 5.33333,
    fill: "#37383A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8612 7.11621C15.0196 7.11621 14.2124 7.44943 13.6173 8.04257C13.0222 8.63571 12.6879 9.44018 12.6879 10.279V11.3953V12.5116C12.6879 12.8198 12.4372 13.0697 12.1279 13.0697H10.4479V14.9302H12.1279C12.4372 14.9302 12.6879 15.1801 12.6879 15.4883V20.8837H14.5545V15.4883C14.5545 15.1801 14.8053 14.9302 15.1145 14.9302H16.9173L17.384 13.0697H15.1145C14.8053 13.0697 14.5545 12.8198 14.5545 12.5116V10.279C14.5545 9.9336 14.6922 9.60235 14.9373 9.35812C15.1823 9.11389 15.5147 8.97668 15.8612 8.97668H17.5412V7.11621H15.8612Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.6c5a12e1b1286acb531459a9fe4da15b.svg";
export { ForwardRef as ReactComponent };